export default "__VITE_ASSET__DoiILidl__"